var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.count > 0)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.search()}}},[_c('v-icon',{attrs:{"color":"yellow lighten-1","large":""}},[_vm._v("mdi-folder")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }